import { Component, OnInit, ViewChild } from '@angular/core'
import { ActivatedRoute, ParamMap, Router } from '@angular/router'
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component'
import { WbsService } from 'src/app/services/wbs.service'
import { environment } from 'src/environments/environment'
import {
    IsIgxDialogComponent,
    IsIgxDialogMessageComponent,
    IsIgxHubComponent,
    IsIgxMappingComponent,
} from '@interserve/igx-angular'
import { IsAccountService, IsApiService } from '@interserve/angular'

@Component({
    selector: 'app-update-wbs-item',
    templateUrl: './update-wbs-item.component.html',
    styleUrls: ['./update-wbs-item.component.scss'],
})
export class UpdateWbsItemComponent implements OnInit {
    @ViewChild('snackbar', { static: true }) private snackbar!: SnackbarComponent

    public appCd = environment.appCd
    public frontendCd = 'updateWbsItemV3'
    public hubFrontendCd = 'updateWbsItemHubV3'
    public catalogHubFrontendCd = 'updateWbsItemCatalogHubV3'
    public selectedCatalogHubFrontendCd = 'updateWbsItemCatalogSelectHubV3'
    public title = 'wbs-item更新'

    public apiLoading = false
    public loading = false

    public customerId = ''
    private selectedWbsItemId = ''
    private selectedAreaId = ''

    public mappingData: any = {}
    public mappingDataHub: any = {}
    public mappingDataCatalogHub: any = {}
    public mappingDataselectedCatalogHub: any = {}
    paramData: any = {}
    paramDataForSelectedCatalogHub: any = {}
    dialogMessageCd = 'confirmRun'
    selectedCatalogIds: string[] = []

    @ViewChild('map', { static: false }) public map: IsIgxMappingComponent | undefined
    @ViewChild('catalogHub', { static: true }) public catalogHub: IsIgxHubComponent | undefined
    @ViewChild('selectedCatalogHub', { static: true }) public selectedCatalogHub: IsIgxHubComponent | undefined
    @ViewChild('messageDialog', { static: true }) public messageDialog: IsIgxDialogMessageComponent | undefined

    constructor(
        private wbsService: WbsService,
        private isAccountService: IsAccountService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private isApiService: IsApiService
    ) {}

    ngOnInit() {
        this.customerId = this.isAccountService.account?.customerId ?? ''
        this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
            this.selectedAreaId = params.get('areaId') ?? ''
            this.selectedWbsItemId = params.get('wbsItemId') ?? ''
        })
        this.initialize()
    }
    async initialize() {
        this.loading = true
        try {
            // 紐づけWBSの設定
            let settings = await this.wbsService.getFrontendSettings(this.appCd, this.frontendCd)
            if (settings !== null) {
                this.paramData = { wbsItemId: this.selectedWbsItemId }
                this.mappingData = settings
            }
            // Hub(wbs作成)の設定
            let hubsettings = await this.wbsService.getFrontendSettings(this.appCd, this.hubFrontendCd)
            if (hubsettings !== null) {
                this.mappingDataHub = hubsettings
            }
            // Hub(カタログ)の設定
            let catalogHubsettings = await this.wbsService.getFrontendSettings(this.appCd, this.catalogHubFrontendCd)
            if (catalogHubsettings !== null) {
                this.paramData = { ...this.paramData, fileSystemId: this.selectedAreaId }
                this.mappingDataCatalogHub = catalogHubsettings
            }

            let selectedCatalogHubsettings = await this.wbsService.getFrontendSettings(
                this.appCd,
                this.selectedCatalogHubFrontendCd
            )
            if (selectedCatalogHubsettings !== null) {
                this.mappingDataselectedCatalogHub = selectedCatalogHubsettings
            }
            this.loading = false
        } catch (error) {
            this.snackbar.error('画面の初期化が失敗しました')
            this.loading = false
        }
    }
    actions = {
        selectCatalog: (event: any) => {
            this.catalogHub?.open()
        },
        saveDialog: (event: any) => {
            this.dialogMessageCd = 'confirmRun'
            this.messageDialog?.open()
        },
    }
    selectedElementId: string = ''
    catalogHubActions = {
        cellClick: (event: any) => {
            if (event.added.length) {
                this.selectedElementId = event.added[0].id
            } else {
                this.selectedElementId = ''
            }
        },
        select: (event: any) => {
            const selected = event.leftWbs.selected
            if (selected.length) {
                this.paramDataForSelectedCatalogHub = { fileSystemId: (this.selectedAreaId = selected[0].id) }
                this.selectedCatalogHub?.open()
            }
            this.catalogHub?.close()
        },
    }
    selectedCatalogHubActions = {
        select: (event: any) => {
            const selected = event.leftWbs.selected
            if (selected?.length) {
                const data = this.map?.getData('rightWbsData') ?? []
                this.map?.setData('rightWbsData', data.concat(selected))
            }
            this.selectedCatalogIds.push(this.paramDataForSelectedCatalogHub.fileSystemId)
            this.selectedCatalogHub?.close()
        },
    }

    dialogAction(eventCd: string) {
        if (eventCd === 'save') {
            this.save()
        }
        this.messageDialog?.close()
    }

    async save() {
        const leftWbs = this.map?.getData('leftWbsData')
        //wbs-item更新
        if (leftWbs?.length) {
            //wbs-itemの取得
            const appCd = 'documentWbs'
            this.isApiService.sendApiRequest
            const domain = `${appCd}.${environment.environmentKey}.getIndexWbs`
            const wbsItem = await this.isApiService.convertUrlAfterSend(domain, {
                fileSystemId: this.selectedWbsItemId,
            })
            let wbsIndex = wbsItem?.data?.nodeObjects?.find((x: any) => x.wbsType === 'wbs-index')
            if (!wbsItem) {
                console.log('システムエラーが発生しました')
                this.dialogMessageCd = 'apiFailed'
                this.messageDialog?.open()
                return
            }
            //wbs-itemの更新
            let wbsItemReqObjects = wbsItem?.data?.nodeObjects?.filter((x: any) => x.wbsType !== 'wbs-index')
            let wbsItemReq = wbsItem?.data
            //カタログ追加があれば追加
            if (this.selectedCatalogIds.length > 0) {
                for (let catalogId of this.selectedCatalogIds) {
                    wbsItemReqObjects = wbsItemReqObjects.concat({
                        wbsType: 'catalog',
                        id: catalogId,
                    })
                }
            }
            wbsItemReq.nodeObjects = wbsItemReqObjects.concat(leftWbs)
            const registDomain = `${appCd}.${environment.environmentKey}.postWbsItemAllByIds`
            const retpost = await this.isApiService.convertUrlAfterSend(registDomain, {
                wbsItemId: wbsItemReq.id,
                wbsIndexId: wbsIndex.id,
                payload: wbsItemReq,
            })
            if (!retpost) {
                console.log('システムエラーが発生しました')
                this.dialogMessageCd = 'apiFailed'
                this.messageDialog?.open()
                return
            }
        }

        await this.initialize()
        this.dialogMessageCd = 'apiExceuted'
        this.messageDialog?.open()
    }
    gotoArea() {
        this.router.navigate([`/select-area`])
    }
    selectItem(item: any) {
        console.log('selectItem:')
    }
}
